import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { PAYMENT_METHODS_ROUTE_PATHS, PM_SCOPE } from './config';

export const PAYMENT_METHODS_ROUTES: TApplicationRoute[] = [
  {
    id: 'payment-methods',
    path: PAYMENT_METHODS_ROUTE_PATHS.paymentMethods,
    component: lazy(() => import('./pages/payment-methods-page')),
    layout: 'default',
    permissions: { scopes: [PM_SCOPE] },
    menu: {
      title: 'Payment Methods',
    },
  },
  {
    id: 'payment-method-detail',
    path: PAYMENT_METHODS_ROUTE_PATHS.paymentMethodDetail,
    component: lazy(() => import('./pages/payment-method-detail-page')),
    layout: 'default',
    permissions: { scopes: [PM_SCOPE] },
  },
  {
    id: 'payment-method-rules',
    path: PAYMENT_METHODS_ROUTE_PATHS.paymentMethodRules,
    component: lazy(() => import('./pages/payment-method-rules-page')),
    layout: 'default',
    permissions: { scopes: [PM_SCOPE] },
  },
];
